import { useQuery } from '@tanstack/react-query';
import { Group } from '../../../../../types';
import { useState } from 'react';
import {
  UserKeys,
  getUserGroups,
  getUserQuery,
} from '../../../../api/users-api';
import UserGroups from './user-groups';
import { useParams } from 'react-router-dom';
import { Messages } from '../../../../utils/message-constants';
import { useUserSettings } from '../../../../utils/use-user-settings';

import CircularProgress from '@mui/material/CircularProgress';
import Stack from '@mui/material/Stack';

export default function UserGroupsPage() {
  const { userEmail } = useParams() as { userEmail: string };
  const { userRoles } = useUserSettings();

  const { data: user } = useQuery(getUserQuery(userEmail));

  const [paginationModel, setPaginationModel] = useState<{
    cursor: string | null;
    results: Group[];
    nameSpace: string;
    firstPull: boolean;
    searchTime: number;
    pageSize: number;
  }>({
    cursor: null,
    results: [],
    nameSpace: '',
    firstPull: true,
    searchTime: 0,
    pageSize: 100,
  });

  const {
    data: groups,
    isLoading: groupsLoading,
    isFetching: groupsFetching,
  } = useQuery({
    queryKey: [UserKeys.UserGroups, paginationModel, userEmail],
    queryFn: () => getUserGroups(userEmail, paginationModel),
    meta: {
      errorMessage: Messages.Errors.Network.Loading('groups'),
    },
  });

  if (!user) {
    return (
      <Stack
        justifyContent="center"
        alignItems="center"
        sx={{ width: '100%', minHeight: 300 }}
      >
        <CircularProgress />
      </Stack>
    );
  }

  return (
    <UserGroups
      user={user}
      groups={groups}
      groupsLoading={groupsLoading}
      groupsFetching={groupsFetching}
      userRoles={userRoles}
      userEmail={userEmail}
      paginationModel={paginationModel}
      setPaginationModel={setPaginationModel}
    />
  );
}
